import { IFeatureStatus } from '../../../shared/interfaces/featureFlag';
import { ajaxGet } from '../ajax';

export function utilGetFeatureFlags() {
    return ajaxGet<IFeatureStatus[]>('/util/featureFlags');
}
